/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Empty_TitleInputs */

const es_admin_traces_empty_title = /** @type {(inputs: Admin_Traces_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron eventos`)
};

const en_admin_traces_empty_title = /** @type {(inputs: Admin_Traces_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events found`)
};

/**
* | output |
* | --- |
* | "No events found" |
*
* @param {Admin_Traces_Empty_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_empty_title = /** @type {((inputs?: Admin_Traces_Empty_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Empty_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_empty_title(inputs)
	return en_admin_traces_empty_title(inputs)
});
export { admin_traces_empty_title as "admin.traces.empty.title" }